/**
 * Languages a user can pick. The UI (public/locales/<code>.json, see src/i18n), the
 * roleplay, its transcript and its feedback all follow the chosen one. The picker takes
 * the list from the backend (services/languageService); SUPPORTED_LANGUAGES is only what
 * it shows until that loads, or if it can't. Adding a language: a code in
 * backend/app/shared/languages.py and here, plus its locale file.
 */
export interface LanguageOption {
  code: string;
  label: string;
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español (Spanish)' },
];

export const DEFAULT_LANGUAGE = 'en';
